// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1ARKn","label":"LabeledBox_label__3g7cp"};